import {createContext} from 'react';

function noop() {}

export const AuctionFilterContext = createContext({
    filter: {},
    setFilter: noop()
});